import { yupResolver } from '@hookform/resolvers/yup'
import { t } from 'i18next'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import { Button } from '../components/Button'
import { Input } from '../components/Input'
import { handleError } from '../helpers/handleError.ts'
import { urlValidation } from '../helpers/validationSchema.ts'
import { iconsEntriesMock } from '../mock/iconsEntriesMock.tsx'
import { updateSocialMedia } from '../services/socialMedia.ts'
import { ModalWrapper } from './ModalWrapper.tsx'

export const EditIconModal = ({
  id,
  name,
  link = '',
  onClose,
  showModal,
  onDelete,
}: ModalProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(urlValidation),
    defaultValues: { link },
  })

  const onSubmit = async (data: { link: string }) => {
    try {
      await updateSocialMedia(data, String(id))
      toast.success(t('linkChanged'))
      onClose()
    } catch (e) {
      handleError(e)
    }
  }

  const getUrl = (name?: string) => {
    const icon = iconsEntriesMock.find((icon) => icon.name === name)
    return icon?.exampleUrl
  }

  return (
    <ModalWrapper onClose={onClose} showModal={showModal}>
      <div className="flex flex-col p-4">
        <h1 className="mb-5 text-center text-sm font-medium">Edit {name}</h1>

        <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
          <Input
            variant={errors.link ? 'danger' : 'primary'}
            type="text"
            placeholder={link}
            className="mb-3 text-sm placeholder:text-textSecondary"
            {...register('link')}
            helperText={errors.link ? errors.link.message : undefined}
          />

          <span className="mb-3 text-xs text-textSecondary">
            {`Example: ${getUrl(name)}`}
          </span>

          <div className="flex flex-col gap-2">
            <Button text={t('save')} type="submit" className="text-white" />

            <Button
              onClick={onDelete}
              text={t('removeIcon')}
              type="button"
              className="border-[1px] border-[#676b5f] bg-transparent shadow-none hover:bg-white"
            />
          </div>
        </form>
      </div>
    </ModalWrapper>
  )
}
